export default __webpack_public_path__ + "static/media/logo.d8d63d4a.svg";